"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchSmtpTokens = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSmtpTokens,
  initiatingActionType: _actions.SmtpTokensActionTypes.LOAD_SMTP_TOKENS,
  requestStatusSelector: _selectors.getFetchSmtpTokensRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSmtpTokens
}));
var createSmtpToken = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createSmtpToken,
  initiatingActionType: _actions.SmtpTokensActionTypes.CREATE_SMTP_TOKEN,
  requestStatusSelector: _selectors.getCreateSmtpTokenRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateSmtpToken
}));
var resetSmtpTokenPassword = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.resetSmtpTokenPassword,
  initiatingActionType: _actions.SmtpTokensActionTypes.RESET_SMTP_TOKEN_PASSWORD,
  requestStatusSelector: _selectors.getResetSmtpTokenPasswordRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.ResetSmtpTokenPassword
}));
var deleteSmtpToken = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteSmtpToken,
  initiatingActionType: _actions.SmtpTokensActionTypes.DELETE_SMTP_TOKEN,
  requestStatusSelector: _selectors.getDeleteSmtpTokenRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.DeleteSmtpToken
}));

var _default = (0, _reduxObservable.combineEpics)(fetchSmtpTokens, createSmtpToken, resetSmtpTokenPassword, deleteSmtpToken);

exports.default = _default;
module.exports = exports.default;